import { useEffect, useState } from "react";

/* The ONE viewport boundary for the whole app.
   Matches the existing CSS `lg` divide (1024px) so mobile-native screens mount
   below it and the untouched desktop layout mounts at/above it. Exactly one tree
   mounts at a time — no duplicate app mount, no duplicate polling. Providers
   (Auth / BetSlip / QueryClient / Geo) live ABOVE this boundary, so a resize that
   crosses it preserves wallet / slip / session / cache state.

   Mobile range is < 1024px; this covers every phone and small tablet in portrait
   AND landscape (390×844 ↔ 844×390 never crosses the boundary, so rotation never
   remounts). Crossing 1024px only happens on a desktop-browser resize. */

export const MOBILE_QUERY = "(max-width: 1023.98px)";

function read() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(read);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    // Safari <14 uses addListener; modern uses addEventListener.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    // Re-sync in case it changed between first render and effect.
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
